export default __webpack_public_path__ + "static/media/thumbnail4.c80d21ec.jpg";